import React from 'react';
// import './DocumentPreviewModal.css';

const DocumentPreviewModal = ({ show, onClose, title, children }) => {
  if (!show) return null;
  return (
    <div className="sleeve-custom-modal-overlay" onClick={onClose}>
      <div className="sleeve-custom-modal-content" onClick={e => e.stopPropagation()}>
        <div className="sleeve-custom-modal-header">
          <div className="sleeve-custom-modal-title">{title}</div>
          <button className="sleeve-custom-modal-close" onClick={onClose} aria-label="Close">
            <i className="bi bi-x-circle" />
          </button>
        </div>
        <div className="custom-modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default DocumentPreviewModal; 